export const ADA_TOKEN_SAFE_DELAY_SECONDS = 15;

export const hasTokenValue = (token) =>
    typeof token === 'string' && token.trim() !== '' && token !== 'null' && token !== 'undefined';

export const readJwtExp = (token) => {
    if (!hasTokenValue(token)) {
        return null;
    }
    const parts = token.split('.');
    if (parts.length !== 3) {
        return null;
    }
    try {
        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
        const { exp } = JSON.parse(atob(padded));
        return Number.isFinite(exp) ? exp : null;
    } catch (e) {
        return null;
    }
};

/**
 * Expiry of a token, in epoch seconds, or null when unknown.
 * window.gtg provides it as a string, sometimes empty: fall back to the JWT exp claim.
 */
export const getTokenExpirySeconds = (token, expiresAtSeconds) => {
    if (!hasTokenValue(token)) {
        return null;
    }
    const declared = expiresAtSeconds ? Number(expiresAtSeconds) : NaN;
    return Number.isFinite(declared) ? declared : readJwtExp(token);
};

export const isUsableToken = (token, expiresAtSeconds, nowMs) => {
    const expiresAt = getTokenExpirySeconds(token, expiresAtSeconds);
    return Boolean(expiresAt) && nowMs < (expiresAt - ADA_TOKEN_SAFE_DELAY_SECONDS) * 1000;
};

export const shouldPushToken = ({ token, expiresAt, pushedToken, force, nowMs }) =>
    isUsableToken(token, expiresAt, nowMs) && (force || token !== pushedToken);
